import React from 'react';
import styled from '@emotion/styled';
import Layout from './Layout';
import StaticHeaderCover from '../StaticHeaderCover';
import { Text } from '../styles';

const Container = styled.div({
  maxWidth: '54rem',
  margin: '0 auto',
  position: 'relative',
  zIndex: 2,
});

const Title = styled(Text)(({ theme }) => ({
  bottom: theme.spacing(8),
  position: 'absolute',
  width: '100%',
  zIndex: 3,
  [theme.breakpoints.down('md')]: {
    bottom: theme.spacing(5),
  },
}));

const SubTitle = styled(Text)(({ theme }) => ({
  bottom: theme.spacing(6),
  position: 'absolute',
  width: '100%',
  zIndex: 3,
  [theme.breakpoints.down('md')]: {
    bottom: theme.spacing(1),
  },
}));

type LayoutProps = {
  children?: React.ReactNode,
  cover: string,
  title?: string,
  subtitle?: string,
  containCover?: boolean,
} & React.ComponentPropsWithoutRef<typeof Container>;

export default function StaticLayout({ cover, title, subtitle, containCover, children, ...rest }: LayoutProps) {
  return (
    <>
      <StaticHeaderCover image={cover} containCover={containCover}>
        {title && <Title variant="h1" align="center">{title}</Title>}
        {subtitle && <SubTitle variant="h1" align="center">{subtitle}</SubTitle>}
      </StaticHeaderCover>
      <Layout disableTopGutter>
        <Container {...rest}>
          {children}
        </Container>
      </Layout>
    </>
  );
}
